import { useTranslation } from "react-i18next";
import { ConfigProvider, App as AntdApp } from "antd";
import enUS from "antd/es/locale/en_US";
import zhTW from "antd/es/locale/zh_TW";
import jaJP from "antd/es/locale/ja_JP";
import dayjs from "dayjs";
import "dayjs/locale/zh-tw";
import "dayjs/locale/ja";
import "dayjs/locale/en";
import { CHECKBOX_SIZE, SLIDER } from "../../config/uiTokens";

export default function AntdConfig({ children }) {
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";

  const getAntdLocale = () => {
    switch (lang) {
      case "zh":
        dayjs.locale("zh-tw");
        return zhTW;
      case "ja":
        dayjs.locale("ja");
        return jaJP;
      default:
        dayjs.locale("en");
        return enUS;
    }
  };

  return (
    <ConfigProvider
      locale={getAntdLocale()}
      theme={{
        token: {
          colorPrimary: "#007dda",
          colorInfo: "#007dda",
          colorSuccess: "#007dda",
          colorWarning: "#ffbd07",
          colorError: "#f22020",
          wireframe: false,
          // 行動優先 + 年長使用者：基準字級拉大（對應 uiTokens FONT / index.css 變數）
          fontSize: 16,
          fontSizeSM: 14,
          fontSizeLG: 18,
          // 次要文字顏色加深，避免過淺灰在淺底上難辨
          colorTextSecondary: "#595959",
          colorTextTertiary: "#8c8c8c",
          // 勾選框／單選圓點邊長（預設 16px 手指難點中）
          controlInteractiveSize: CHECKBOX_SIZE,
        },
        components: {
          Button: {
            fontSize: 16,
            contentFontSize: 16,
            paddingInline: 16,
            controlHeight: 44,
            controlHeightLG: 48,
          },
          Input: {
            activeBorderColor: "#007dda",
            hoverBorderColor: "#007dda",
            // 16px 同時可避免 iOS Safari 聚焦時自動放大頁面
            fontSize: 16,
            controlHeight: 44,
            paddingBlock: 10,
            paddingInline: 12,
          },
          Select: {
            controlHeight: 44,
            fontSize: 16,
          },
          DatePicker: {
            controlHeight: 44,
            fontSize: 16,
          },
          Menu: {
            itemHeight: 48,
            fontSize: 16,
          },
          // 拖曳圓點與軌道放大（預設 10px／4px 手指很難抓）；controlSize 為整條可觸控的高度
          Slider: {
            controlSize: SLIDER.touch,
            railSize: SLIDER.rail,
            handleSize: SLIDER.handle,
            handleSizeHover: SLIDER.handle + 2,
            handleLineWidth: 3,
            handleLineWidthHover: 3,
          },
        },
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
